import { InfoCircleOutlined } from "@ant-design/icons";
import { Button, Card, InputNumber, Radio } from "antd";
import React from "react";


const CurrentPlan = (props) => {
    const { showPriceTier } = props;

    return <Card className="subscription-card">
    <div className="card-content">
      <div className="left_content">
        <div className="card-heading">
        Your Current Plan
        </div>
        <div className="content_item">
            <div className="sub_heading">Food Truck Plan</div>
            <div className="info_label">Your next yearly charge of US $250.00 will be applied to your primary payment method on September 24, 2021.</div>
        </div>
      </div>
      <div className="right_content">
        <div><Button type="primary" className="plan_btn" onClick={showPriceTier}>Change Plans</Button></div>
      </div>
      </div>
  </Card>
};
export default CurrentPlan;